(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  const countdown = document.querySelector('[data-liztr-countdown]');

  if (countdown) {
    const target = new Date(countdown.dataset.target).getTime();
    const label = countdown.querySelector('[data-countdown-label]');
    const fields = {
      days: countdown.querySelector('[data-days]'),
      hours: countdown.querySelector('[data-hours]'),
      minutes: countdown.querySelector('[data-minutes]'),
      seconds: countdown.querySelector('[data-seconds]')
    };

    const pad = (value) => String(value).padStart(2, '0');

    const updateCountdown = () => {
      const remaining = target - Date.now();

      if (!Number.isFinite(target) || remaining <= 0) {
        Object.values(fields).forEach((field) => {
          if (field) field.textContent = '00';
        });
        if (label) label.textContent = 'THE DROP IS LIVE';
        return false;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      fields.days.textContent = pad(Math.floor(totalSeconds / 86400));
      fields.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      fields.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      fields.seconds.textContent = pad(totalSeconds % 60);
      return true;
    };

    updateCountdown();
    const countdownTimer = window.setInterval(() => {
      if (!updateCountdown()) window.clearInterval(countdownTimer);
    }, 1000);
  }

  } catch(e) { console.error(e); }
})();
})();
